var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7l.409-.38L13 .942 12.182 0 6.5 5.3.818 0 0 .942 6.091 6.62z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "4da2431e71f3c6e7524cf933a0bd745c.svg";
export { SvgNavArrowDown as ReactComponent };